export default __webpack_public_path__ + "locales/nl/VersionHistory.json?hash=1c86992f89eff65ff8df631f2d956b06";